module.exports = __webpack_public_path__ + "media/application/images/svgs/__MACOSX/i._con_bullet-3c0e2deba4b6da2aa0bff1c35d99c107.svg";